import AddObligation from "./AddObligation";

export default AddObligation;
